import { useEffect, useState } from "react";
import {
  CampaignType,
  TemplateOptionSettings,
  normalizeSectionSettings,
  sectionTopMenuDefault,
} from "../../../../types/global.types";
import {
  getDisplayedSectionOfferCount,
  getDisplayedSectionOffers,
} from "../utils/sectionDisplay.utils";

interface Props {
  settings: TemplateOptionSettings;
  campaign: CampaignType;
  offers: CampaignType["offers"];
  hasFilters?: boolean;
}

const PreviewTopMenu = ({ settings, campaign, hasFilters }: Props) => {
  const sectionSettings = normalizeSectionSettings(settings.sections);
  const topMenu = sectionSettings.topMenu;
  const align = settings.mainLayout.align || "center";
  const displayedBySection = getDisplayedSectionOffers(
    sectionSettings.sections,
    campaign.offers || []
  );
  const menuItems = sectionSettings.sections
    .map((section, index) => ({
      section,
      index,
      count: getDisplayedSectionOfferCount(displayedBySection[index]),
    }))
    .filter(({ section, count }) => section.includeTopMenu && count > 0);
  const [activeIndex, setActiveIndex] = useState(menuItems[0]?.index ?? 0);

  useEffect(() => {
    if (!menuItems.some(({ index }) => index === activeIndex)) {
      setActiveIndex(menuItems[0]?.index ?? 0);
    }
  }, [menuItems, activeIndex]);

  if (!topMenu.enabled) {
    return null;
  }

  const handleSelect = (index: number) => {
    setActiveIndex(index);
    const section = document.getElementById(`preview-section-${index}`);
    if (!section) {
      return;
    }

    const offset = section.getBoundingClientRect().top - 8;
    section.scrollIntoView({ behavior: "smooth", block: "start" });
    window.parent?.postMessage(
      { event: "scrollToEmbeddedSection", offset },
      "*"
    );
  };

  return (
    <>
      {topMenu.enabled && menuItems.length > 0 && (
        <div
          className={`preview-top-menu preview-top-menu-${align}${hasFilters ? " has-filters" : ""
            }`}
        >

          <div className="preview-top-menu-items">
            {menuItems.map(({ section, index, count }) => {
              const isActive = activeIndex === index;
              const label = section.title;

              return (
                <button
                  type="button"
                  key={`top-menu-${index}`}
                  className={`preview-top-menu-item${isActive ? " is-active" : ""}`}
                  onClick={() => handleSelect(index)}
                  style={{
                    color: isActive ? topMenu.activeTextColor : topMenu.textColor,
                    backgroundColor: isActive
                      ? topMenu.activeBackgroundColor
                      : topMenu.backgroundColor,
                    borderColor: isActive
                      ? topMenu.activeBorderColor
                      : topMenu.borderColor,
                    borderRadius: `${topMenu.borderRadius ?? sectionTopMenuDefault.borderRadius
                      }px`,
                  }}
                >
                  {label !== "" && (
                    <span className="preview-top-menu-item-label">{label}</span>
                  )}
                  <span className="preview-top-menu-item-count">{count}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewTopMenu;
